// Menu lateral em seções. Itens com "children" viram grupos recolhíveis
// (no menu recolhido, abrem como lista flutuante ao lado do ícone).
const data = [
  {
    name: "Geral",
    children: [
      { name: "Visão Geral", icon: "mdi-view-dashboard-outline", route: "/home", permissions: ["dashboard.view"] }
    ]
  },

  {
    name: "Operação",
    children: [
      { name: "Monitoramento", icon: "mdi-car-clock", route: "/monitoramento", permissions: ["trips.view"] },
      { name: "Recorrências", icon: "mdi-calendar-sync-outline", route: "/recorrencias", permissions: ["recurrences.view"] },
      { name: "Logística", icon: "mdi-truck-outline", route: "/logistica", permissions: ["logistics.view"] },
      {
        name: "Cadastros",
        icon: "mdi-map-marker-path",
        children: [
          { name: "Itinerários", route: "/itinerarios", permissions: ["itineraries.view"] },
          { name: "Locais", route: "/locais", permissions: ["locations.view"] },
          { name: "Bairros", route: "/bairros", permissions: [] },
          { name: "Intervalos", route: "/intervalos", permissions: ["intervals.view"] },
          { name: "Pedágios", route: "/pedagios", permissions: ["tolls.view"] },
          { name: "Feriados", route: "/feriados", permissions: ["holidays.view"] }
        ]
      }
    ]
  },

  {
    name: "Clientes",
    children: [
      { name: "Empresas", icon: "mdi-domain", route: "/empresas", permissions: ["customers.view"] },
      { name: "Solicitantes", icon: "mdi-account-tie-outline", route: "/solicitantes", permissions: ["requesters.view"] },
      { name: "Passageiros", icon: "mdi-account-multiple-outline", route: "/passageiros", permissions: ["passengers.view"] },
      { name: "Passageiros em lote", icon: "mdi-account-multiple-plus-outline", route: "/passageiros-lote", permissions: ["passenger-imports.view"] },
      { name: "Centros de custo", icon: "mdi-sitemap-outline", route: "/centro-custo", permissions: ["costcenters.view"] }
    ]
  },

  {
    name: "Frota",
    children: [
      { name: "Veículos", icon: "mdi-car-hatchback", route: "/veiculos", permissions: ["vehicles.view"] },
      { name: "Marcas e modelos", icon: "mdi-car-info", route: "/marcas-modelos", permissions: ["vehicles.view"] },
      { name: "Motoristas", icon: "mdi-card-account-details-outline", route: "/motoristas", permissions: ["drivers.view"] },
      { name: "Abastecimentos", icon: "mdi-gas-station-outline", route: "/abastecimentos", permissions: ["vehicles.view"] },
      {
        name: "Manutenções",
        icon: "mdi-car-wrench",
        children: [
          { name: "Preventivas", route: "/manutencoes", permissions: ["maintenances.view"] },
          { name: "Programações", route: "/manutencoes/programacoes", permissions: ["maintenances.view"] },
          { name: "Corretivas", route: "/manutencoes/corretivas", permissions: ["maintenances.view"] },
          { name: "Estoque de peças", route: "/manutencoes/estoque", permissions: ["maintenances.view"] },
          { name: "Fornecedores", route: "/manutencoes/fornecedores", permissions: ["maintenances.view"] }
        ]
      }
    ]
  },

  {
    name: "Financeiro",
    children: [
      { name: "Painel financeiro", icon: "mdi-finance", route: "/financeiro", permissions: ["financial.view"] },
      { name: "Receitas", icon: "mdi-cash-plus", route: "/financeiro/receitas", permissions: ["financial.view"] },
      { name: "Despesas", icon: "mdi-receipt-text-outline", route: "/financeiro/despesas", permissions: ["financial.view"] },
      { name: "Motoristas a pagar", icon: "mdi-account-cash-outline", route: "/financeiro/motoristas", permissions: ["financial.view"] },
      { name: "Custos de veículos", icon: "mdi-car-cog", route: "/financeiro/veiculos", permissions: ["financial.view"] },
      { name: "DRE", icon: "mdi-table-large", route: "/financeiro/dre", permissions: ["financial.view"] }
    ]
  },

  {
    name: "Administração",
    children: [
      { name: "Administradores", icon: "mdi-shield-account-outline", route: "/administradores", permissions: ["admins.view"] },
      { name: "Papéis", icon: "mdi-account-key-outline", route: "/papeis", permissions: ["roles.view"] },
      { name: "Auditoria", icon: "mdi-shield-search", route: "/auditoria", permissions: ["audits.view"] }
    ]
  }
];

export default [...data];
